/**
 * If your page doesn't need its own js/less, use semantic_generic_page.js/less.
 * Adding code here will have it run on all pages that use this, so be careful!
 * General/safe code like form validation are the kinds of things that are appropriate in this file,
 * otherwise make sure you only run code conditionally
 */
require([
    'jquery',
    'services',
    'semantic',
    'ch_header',
    'ch_form_validation',
    'ch_semantic_responsive'
], function ($) {
    $(function() {
        $('.ui.form').each(function (index, form) {
            CH.validate($(form));
        });

        $('.ui.rating').rating(
            {
                maxRating: 5,
                interactive: false
            }
        );
    });
});
